import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import ModalButton from 'components/ModalButton';

interface SavePictureButtonProps {
  onSave: () => void;
}

const ButtonContainer = styled(ModalButton)`
  display: block;
  margin: 12px 4px 16px;
`;

const SavePictureButton = ({ onSave }: SavePictureButtonProps) => {
  const { t } = useTranslation();

  return (
    <ButtonContainer
      type="button"
      id="profile-picture-save-button"
      onClick={onSave}
    >
      {t('save')}
    </ButtonContainer>
  );
};

export default SavePictureButton;
